export const GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING =
  "GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING";
export const EXPORT_STORICO_LOADING = "EXPORT_STORICO_LOADING";
export const GET_STORICO_FILTER_DATA = "GET_STORICO_FILTER_DATA";
